// import { useLocalStorage } from "@/composables/useLocalStorage";

const menuList = {
    namespaced: true,
    state: () => ({
        menu: [
            {
                key: 0,
                icon: 'ti-settings',
                label: '데일리 브리핑',
                is_role: false,
                path : '/daily-briefing',
            },
            {
                key: 1,
                icon: 'ti-smart-home',
                label: '관리자 정보',
                is_role: true,
                path : '/admin',
            },
        ],
        isSideMenu : false,
    }),
    mutations: {
        // setActiveMenu : (state,payload) => {
        //     state.menu.forEach((item)=>{
        //         item.is_active = item.key === payload;
        //     });
        // },
        setSideMenu(state,payload){
            state.isSideMenu = payload;
        },
    },
    actions: {
        handleApiError({ commit }, payload) {
            commit("setApiError", payload);
        }
    },
    getters: {
        menuList: (state) => {
            return state.menu;
            // const role = useLocalStorage("role");
            // if(role.value == 2){
            //     return state.menu.filter((item)=>item.role === 0);
            // }else{
            //     return state.menu;
            // }
        },
    }
}

export default menuList; 